import { useEffect } from "react";
import { SiteFooter } from "../components/SiteFooter.jsx";

const PAGES = {
  "/sobre": [
    "Party Games",
    "Sobre",
    "Um portal de minigames para jogar sozinho ou com amigos.",
    [
      [
        "Diversão sem complicação",
        "Crie uma sala, compartilhe o código de quatro letras e comece a partida. O Party Games reúne jogos de palavras, raciocínio, velocidade e criatividade.",
      ],
      [
        "Feito para grupos",
        "As salas sincronizam jogadores, rodadas e pontuações em tempo real. Também há modos solo com rankings opcionais.",
      ],
    ],
  ],
  "/como-jogar": [
    "Guia rápido",
    "Como jogar",
    "Escolha um apelido e crie uma sala ou entre usando um código.",
    [
      [
        "Jogar com amigos",
        "O anfitrião cria a sala e compartilha o código. Depois escolhe o jogo, configura as rodadas e inicia a partida para até oito jogadores.",
      ],
      [
        "Jogar sozinho",
        "Escolha Termo, Quebra-Cabeça ou Stop na página inicial. A conta Google é opcional e serve para registrar resultados nos rankings.",
      ],
      [
        "Pontuação",
        "Cada jogo possui regras próprias. No Stop, respostas únicas valem 10 pontos e respostas repetidas valem 5 após a votação.",
      ],
    ],
  ],
  "/contato": [
    "Fale com a gente",
    "Contato",
    "Envie dúvidas, sugestões ou relatos de problemas.",
    [
      [
        "Redes sociais",
        "Você pode encontrar o criador do Party Games no Instagram e na Twitch usando o nome eulokismt.",
      ],
      [
        "Ao relatar um erro",
        "Informe o jogo, o que estava fazendo e, se existir, o código da sala. Não envie senhas ou dados sensíveis.",
      ],
    ],
  ],
  "/privacidade": [
    "Transparência",
    "Política de Privacidade",
    "Como dados de salas, rankings, autenticação e publicidade são utilizados.",
    [
      [
        "Dados utilizados",
        "O serviço processa apelidos, identificadores técnicos de jogadores, estado temporário das salas e resultados enviados aos rankings. Ao usar login Google, nome público e foto podem aparecer no ranking.",
      ],
      [
        "Armazenamento",
        "Salas e rankings usam Firebase. Preferências de som e recuperação temporária de partidas podem ser guardadas no navegador.",
      ],
      [
        "Publicidade",
        "O site usa a rede Adcash para ajudar a financiar sua manutenção, incluindo AutoTag e espaços laterais de publicidade em telas compatíveis. A biblioteca de publicidade é carregada automaticamente junto com a página.",
      ],
      [
        "Cookies e tecnologias da Adcash",
        "A Adcash e parceiros de publicidade podem colocar ou ler cookies, usar pixels ou web beacons e processar dados técnicos, como endereço IP, localização aproximada, navegador, sistema operacional, páginas acessadas e frequência de uso, para entregar, limitar e medir anúncios.",
      ],
      [
        "Suas escolhas",
        "Você pode bloquear ou remover cookies de publicidade nas configurações do navegador. Mensagens adicionais de consentimento poderão ser exibidas pela rede de anúncios quando exigidas para a região do visitante.",
      ],
      [
        "Seus cuidados",
        "Não use informações pessoais como apelido e não compartilhe códigos de sala publicamente quando quiser uma partida privada.",
      ],
    ],
  ],
  "/termos": [
    "Regras do serviço",
    "Termos de Uso",
    "Condições básicas para usar o Party Games com segurança.",
    [
      [
        "Uso aceitável",
        "Não use o serviço para assediar participantes, fraudar rankings, explorar falhas ou enviar conteúdo ilegal ou inadequado.",
      ],
      [
        "Conteúdo dos jogadores",
        "Quem envia nomes, respostas ou seleciona imagens é responsável por ter autorização e manter o conteúdo apropriado.",
      ],
      [
        "Publicidade e tráfego válido",
        "Não clique nos próprios anúncios, não peça que outras pessoas cliquem, não use robôs, tráfego artificial, recarregamentos automáticos, incentivos ou qualquer método para gerar impressões, cliques ou conversões sem interesse real.",
      ],
      [
        "Disponibilidade",
        "O serviço pode passar por manutenção ou sofrer interrupções. Partidas e pontuações temporárias podem não ser recuperáveis em todos os casos.",
      ],
      [
        "Serviços externos",
        "Autenticação, banco de dados e publicidade podem depender de fornecedores externos e também estão sujeitos às políticas deles.",
      ],
    ],
  ],
};

export const INSTITUTIONAL_PATHS = Object.keys(PAGES);

export function InstitutionalPage({ path }) {
  const [eyebrow, title, summary, sections] = PAGES[path] || PAGES["/sobre"];
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} — Party Games`;
    window.scrollTo(0, 0);
    return () => {
      document.title = previous;
    };
  }, [title]);
  return (
    <div className="portal-page institutional-page">
      <div className="institutional-shell">
        <header className="institutional-topbar">
          <a className="brand-lockup portal-brand" href="/">
            <span className="brand-symbol" aria-hidden="true">
              <img src="/icone.png" alt="" />
            </span>
            <span>
              <strong>Party Games</strong>
              <small>Minigames com a galera</small>
            </span>
          </a>
          <a className="institutional-back" href="/">
            ← Voltar aos jogos
          </a>
        </header>
        <main className="institutional-main">
          <div className="institutional-hero">
            <span>{eyebrow}</span>
            <h1>{title}</h1>
            <p>{summary}</p>
          </div>
          <article className="institutional-content">
            {sections.map(([heading, content]) => (
              <section key={heading}>
                <h2>{heading}</h2>
                <p>{content}</p>
              </section>
            ))}
          </article>
        </main>
        <SiteFooter />
      </div>
    </div>
  );
}
